import * as React from 'react';
import { Route, Routes, useParams } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'common/react-query/query-client';
import { getProjectId, getWorkspaceId } from 'common/report/util';
import { ReactErrorBoundary } from 'common/components/react-error-boundary';
import { ExperimentPage } from 'apps/experiments/src/components/page';
import { ExperimentListPage } from 'apps/experiments/src/components/list-page';
import { userCookieUtils } from 'common/report/util/user-identity-from-cookie';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { ProjectFeatureFlag } from 'common/report/constants';
import styles from './index.module.styl';
type ViewProps = {
  projectId: number;
  workspaceId: number;
  featureFlagIntegrationEnabled: boolean;
};
const View: React.FC<ViewProps> = props => {
  var _userCookieUtils$getU, _userCookieUtils$getU2;
  const {
    experimentId
  } = useParams<{
    experimentId: string;
  }>();
  return <ExperimentPage projectId={props.projectId} workspaceId={props.workspaceId} featureFlagIntegrationEnabled={props.featureFlagIntegrationEnabled} userId={(_userCookieUtils$getU = (_userCookieUtils$getU2 = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU2 === void 0 ? void 0 : _userCookieUtils$getU2.id) !== null && _userCookieUtils$getU !== void 0 ? _userCookieUtils$getU : 0} experimentId={experimentId!} data-sentry-element="ExperimentPage" data-sentry-component="View" data-sentry-source-file="index.tsx" />;
};
type ListProps = {
  projectId: number;
  workspaceId: number;
  featureFlagIntegrationEnabled: boolean;
};
const List: React.FC<ListProps> = props => {
  var _userCookieUtils$getU3, _userCookieUtils$getU4;
  return <ExperimentListPage projectId={props.projectId} workspaceId={props.workspaceId} featureFlagIntegrationEnabled={props.featureFlagIntegrationEnabled} userId={(_userCookieUtils$getU3 = (_userCookieUtils$getU4 = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU4 === void 0 ? void 0 : _userCookieUtils$getU4.id) !== null && _userCookieUtils$getU3 !== void 0 ? _userCookieUtils$getU3 : 0} data-sentry-element="ExperimentListPage" data-sentry-component="List" data-sentry-source-file="index.tsx" />;
};

// for lazy loading route
// eslint-disable-next-line import/no-default-export
export default function () {
  var _useCurrentProject$ge;
  const projectId = parseInt(getProjectId(), 10);
  const workspaceId = parseInt(getWorkspaceId(), 10);
  const featureFlagIntegrationEnabled = ((_useCurrentProject$ge = useCurrentProject().get().value) === null || _useCurrentProject$ge === void 0 ? void 0 : _useCurrentProject$ge.hasFeatureFlag(ProjectFeatureFlag.FeatureFlagsApp)) || false;
  return <div className={styles.appContainer}>
      <ReactErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route path='' element={<List projectId={projectId} workspaceId={workspaceId} featureFlagIntegrationEnabled={featureFlagIntegrationEnabled} />} />
            <Route path=':experimentId' element={<View projectId={projectId} workspaceId={workspaceId} featureFlagIntegrationEnabled={featureFlagIntegrationEnabled} />} />
          </Routes>
        </QueryClientProvider>
      </ReactErrorBoundary>
    </div>;
}